
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { SystemAttributes } from '../attributes.model';
import { formatDate, vSelectInModalWithPopper } from '../../../../../../util';
import { KanbanState } from '../../../../kanban.model';
import ActivityStore from '../../../../../../stores/ActivityStore';
import { Board } from '../../../../../backend/backendapi';
import { isBoardNotInSelectedAccount } from '../../../../kanban.util';

type VSelectItem = { id: number, name: string };

@Component({
  components: {
    vSelect,
  },
})
export default class ActivityAttributeEditor extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly board!: Board;
  @Prop({ required: true })
  readonly attributes!: SystemAttributes;

  readonly activityStore = new ActivityStore();

  vSelectInModalWithPopper = vSelectInModalWithPopper;

  get activitiesForVSelect(): VSelectItem[] {
    return this.activityStore.activities.map(e => ({
      id: e.id!,
      name: (e.title ?? '') + ' (' + formatDate(e.currentDate!) + ', ' + this.$t('kanbanCardCell') + ': ' + e.cellName + ')',
    }));
  }

  get activityId(): number | null {
    return this.attributes.activityId ?? null;
  }

  set activityId(activityId: number | null) {
    this.attributes.activityId = activityId ?? undefined;
  }

  get isBoardNotInSelectedAccount(): boolean {
    return isBoardNotInSelectedAccount(this.board, this.state.accounts);
  }

  mounted(): void {
    this.activityStore.loadIfAbsent();
  }

  @Watch('state.accounts')
  private onAccountChanged(): void {
    this.activityStore.reload();
  }
}
